import styled from "@emotion/styled"
import { Paper, Container } from "@mui/material";

export const CardNumber = styled.b`
    font-size: 1rem;
    @media (min-width: 1024px) {
        font-size: 1.1rem ;
    }
`

export const CardLabel = styled.span`
    font-size: 0.75rem;
    line-height: 1;
    @media (min-width: 1024px) {
        font-size: 0.9rem;
}`

export const CardNumbersContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const SCTeamCardNumber = styled.b`
    font-size: 1.5rem;
    @media (min-width: 1024px) {
        font-size: 1.5rem ;
    }
`

export const SCTeamCardLabel = styled.span`
    font-size: 1rem;
    line-height: 1;
    @media (min-width: 1024px) {
        font-size: 1rem;
    }
`

export const SCTeamMetricsContainer = styled.div`
    display: flex;
    column-gap: 2rem;
    flex-wrap: wrap;
    @media(max-width: 800px) {
        flex-direction: row;
        justify-content: center;
        row-gap: 1rem;
        .rank-metric, .rd-metric {
            width: 40%;
        }
        .price-metric {
            width: 100%;
        }
    }
`

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
`;

export const RoundedCTAContainer = styled.div`
    display: grid;
    column-gap: 0.5rem;
    @media(max-width: 800px) {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        row-gap: 0.5rem;
        h4 {
            font-size: 0.75rem;
        }
    }
    
    @media(min-width: 800px) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        
    }
    
`

export const RoundedCTAPaper = styled(Paper)`
    cursor: pointer;
    border-radius: 5%;
    display: flex;
    flex-direction: row;
    column-gap: 1rem;
    align-items: center;
    @media(min-width: 800px) {
        padding: 0.75rem;
        padding-right: 1.5rem;
        padding-left: 1.5rem;
    }

    @media(max-width: 800px) {
        padding: 0.5rem;
        h4 {
            font-size: 1rem !important;
        }
    }
    
`

export const PageContainer = styled(Container)`
    min-height: 90vh;
    @media (min-width: 600px) {
        padding-left: 2rem !important;
        padding-right: 2rem !important;
    }
`;